export const JUSTIFY_START = 'start';
export const JUSTIFY_END = 'end';
export const JUSTIFY_CENTER = 'center';
export const JUSTIFY_BETWEEN = 'between';
export const JUSTIFY_AROUND = 'around';
